import { render, staticRenderFns } from "./labelSetting.vue?vue&type=template&id=41ed5cfd&scoped=true"
import script from "./labelSetting.vue?vue&type=script&lang=js"
export * from "./labelSetting.vue?vue&type=script&lang=js"
import style0 from "./labelSetting.vue?vue&type=style&index=0&id=41ed5cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed5cfd",
  null
  
)

export default component.exports